export default {
  currencyConvert: {
    'GBPen-IE': 1.1373976342,
    'EURen-GB': 0.8792,
  },
}
